import i18n from 'i18next';
import I18NextHttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import de from '../../locales/de.json';
import en from '../../locales/en.json';
import es from '../../locales/es.json';
import fr from '../../locales/fr.json';
import it from '../../locales/it.json';
import tr from '../../locales/tr.json';

i18n
  .use(I18NextHttpBackend)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false, // Changed for v16 compatibility
    },
    resources: {
      en: {
        translation: en,
      },
      it: {
        translation: it,
      },
      es: {
        translation: es,
      },
      fr: {
        translation: fr,
      },
      de: {
        translation: de,
      },
      tr: {
        translation: tr,
      },
    },
    // i18next v25 configuration
    lng: 'en',
    debug: false,
    load: 'languageOnly',
    preload: ['en', 'it', 'es', 'fr', 'de', 'tr'],
    supportedLngs: ['en', 'it', 'es', 'fr', 'de', 'tr'],
  });

function syncDocumentLanguage(language: string): void {
  const languageCode = language.split('-')[0] ?? 'en';
  document.documentElement.lang = languageCode;
}

syncDocumentLanguage(i18n.language);
i18n.on('languageChanged', syncDocumentLanguage);

export default i18n;
